import React, { useState } from 'react';
import styled from 'styled-components';

import CreateUnitsContainer from '../../../../containers/dashboards/cards/create/CreateUnitsContainer';
import CreateHeaderDashboard from './CreateHeaderDashboard';

const StyledPage = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-wrap: nowrap;
  flex: 1;
`;

const CreateDashboardPage = ({
  dashboard,
  onBack,
  dashboardName,
  setDashboardName,
  saveDashboard,
  existedDashboardNames,
  isCreate,
  units,
}) => {
  const [showNotValidFields, setShowNotValidFields] = useState(false);

  return (
    <StyledPage>
      <CreateHeaderDashboard
        onBack={onBack}
        dashboardName={dashboardName}
        setDashboardName={setDashboardName}
        saveDashboard={saveDashboard}
        existedDashboardNames={existedDashboardNames}
        sourceDashboardName={dashboard.name}
        setShowNotValidFields={setShowNotValidFields}
        isCreate={isCreate}
        units={units}
      />
      <CreateUnitsContainer showNotValidFields={showNotValidFields} />
    </StyledPage>
  );
};

export default CreateDashboardPage;
